<template>
  <div class="left_block my-courses">
    <p class="header">
      <span class="link" @click="$router.push('/my-courses')"
        >Мои курсы <i style="font-size: 10px;" class="icon-button-arrow"></i
      ></span>
      <span class="link" @click="$router.push('/course-info/' + currentCourse.id)"
        >{{ currentCourse.name }} <i style="font-size: 10px;" class="icon-button-arrow"></i
      ></span>

      {{ stageInfo.name }}
    </p>

    <CourseTest
      v-if="stageInfo.type === 2 || stageInfo.type === 3"
      :test-props="testProps"
      :stage-info="stageInfo"
      :course-info="currentCourse"
      :is-leave-modal-open="isLeaveModalOpen"
      @reload-test="reloadTest"
    />

    <CourseLesson :course-id="courseId" v-if="stageInfo.type == 1" :current-stage="stageInfo" />

    <CourseControls
      v-if="!testProps.isTestStarted"
      @backStage="changeStage('back')"
      @nextStage="changeStage('next')"
      :button-text="buttonText"
      :show="isFirstButtonShow"
    />

    <!-- <CourseDescription :stage-info="stageInfo" v-if="!testProps.isTestStarted" /> -->

    <b-modal :active.sync="isLeaveModalOpen === 'home!auth' ? false : isLeaveModalOpen" has-modal-card scroll="keep">
      <LeaveModal />
    </b-modal>

    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
  </div>
</template>

<script>
import CourseTest from '@/components/user/my-courses/CourseTest'
import CourseLesson from '@/components/user/my-courses/CourseLesson'
import CourseControls from '@/components/user/my-courses/CourseControls'
// import CourseDescription from '@/components/user/my-courses/CourseDescription'
import LeaveModal from '@/components/modal/LeaveModal'

export default {
  components: {
    CourseControls,
    // CourseDescription,
    CourseTest,
    LeaveModal,
    CourseLesson
  },
  data() {
    return {
      isLoading: true,
      image: '',
      testProps: this.defaultTestProps(),
      isLeaveModalOpen: false,
      isButtonShow: true
    }
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.auth
    },
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    rightCoursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    },
    currentCourse() {
      const course = this.rightCoursesList.find((el) => el.id === Number(this.courseId))
      if (course) {
        return course
      }
      return {
        name: '',
        stages: []
      }
    },
    stageInfo() {
      return this.$store.state.stage.userStageInfo
    },
    courseId() {
      return Number(this.$route.query.courseId)
    },
    stageId() {
      return Number(this.$route.params.id)
    },
    buttonText() {
      if (!this.stageInfo) {
        return 'Завершить курс'
      }
      if (this.stageInfo.sort_number === this.currentCourse.stages.length - 1) {
        return 'Завершить курс'
      }
      return 'Следующий урок'
    },
    isFirstButtonShow() {
      if (!this.stageInfo) {
        return false
      }
      if (this.stageInfo.sort_number === 0) {
        return false
      }
      return true
    }
  },
  methods: {
    changeStage(direction, stageId) {
      let currentCourse = this.rightCoursesList.find((course) => course.id === this.courseId)
      if (!currentCourse) {
        this.rightCoursesList.forEach((course) => {
          if (course.stages.find((stage) => stage.id === this.stageId)) {
            currentCourse = course
            return
          }
        })
      }
      const currentStage = stageId ? currentCourse.stages.find((stage) => stage.id === stageId) : this.stageInfo
      let index = direction === 'next' ? currentStage.sort_number + 1 : currentStage.sort_number - 1
      if (currentCourse.stages[index]) {
        this.$router.push(
          '/my-courses/' + currentCourse.stages[index].id + '?direction=' + direction + '&courseId=' + currentCourse.id
        )
        return
      }
      this.$router.push('/my-courses/')
    },
    reloadTest() {
      this.loadStage(this.stageId, 'next')
    },
    loadCourses() {
      this.$axios2
        .get('courses')
        .then((resp) => {
          this.$store.commit('setUserRightCoursesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    loadStage(ID, direction) {
      this.isLoading = true
      this.$axios2
        .get('/courses/' + this.courseId + '/stages/' + ID)
        .then((resp) => {
          this.$store.commit('setUserStageInfo', { list: resp.data })
          // this.$router.push('/my-courses/' + resp.data.data.id)
          this.testProps = this.defaultTestProps()
          this.testProps.attempt_number = resp.data.user_test_attempts_count
          this.isLoading = false
          let currentStage = this.currentCourse.stages.find((stage) => stage.id === resp.data.id)
          if (resp.data.type !== 1 || currentStage.passed) return
          this.$axios2.post('/courses/' + this.courseId + '/stages/' + ID + '/pass').then(this.loadCourses)
        })
        .catch((err) => {
          this.isLoading = false
          this.changeStage(direction, ID)
          this.$errorToast(err)
        })
    },
    leaveModalConfig(to, from, next, action) {
      if (to.name === 'home' && !this.isAuth) {
        this.isLeaveModalOpen = 'home!auth'
        this.$nextTick(() => {
          next()
        })
        return
      }
      if (this.testProps.isTestStarted) {
        this.isLeaveModalOpen = true
        this.$nextTick(() => {
          document.getElementById('confirm-leave-btn').addEventListener('click', () => {
            this.isLeaveModalOpen = false
            next()
            if (to.name === 'my-courses_id') {
              this.loadStage(this.stageId, to.query.direction || 'next')
            }
          })
          document.getElementById('abort-leave-btn').addEventListener('click', () => {
            this.isLeaveModalOpen = false
            next(false)
          })
        })
        return
      } else {
        next()
        if (to.name === 'my-courses_id' && action === 'update') {
          this.loadStage(this.stageId, to.query.direction || 'next')
        }
      }
    },
    defaultTestProps() {
      return {
        isTestStarted: false,
        isEndPage: false,
        isStartPage: true,
        sec: 0,
        ten_sec: 0,
        min: 0,
        ten_min: 0,
        least_sec: 0,
        least_ten_sec: 0,
        attempt_number: 0
      }
    }
  },
  mounted() {
    this.loadStage(this.stageId, 'next')
  },
  beforeDestroy() {
    window.onbeforeunload = ''
  },
  beforeRouteLeave(to, from, next) {
    this.leaveModalConfig(to, from, next, 'leave')
  },
  beforeRouteUpdate(to, from, next) {
    this.leaveModalConfig(to, from, next, 'update')
  }
}
</script>
